module.exports = __webpack_public_path__ + "media/images/arrow-down-00fc4bad0284e7cfd64fad8121c3c121.svg";